import { ThemeSettingsBaseSectionHandler } from '../settings.section';
import { ThemeResponse } from '@key-telematics/fleet-api-client';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { AdminEditorService } from '../../../admin.service';
import { ThemeEngine } from 'app/shared/components/theme';

export class TabSettingsSectionHandler extends ThemeSettingsBaseSectionHandler {

    constructor(admin: AdminEditorService, ownerId: string, themeEngine: ThemeEngine) {
        super(admin, ownerId, themeEngine, 'tab');
    }

    async getFields(_entity: ThemeResponse): Promise<FormBuilderField[]> {
        return [

            this.fontFamilyField('font.family', ['main', 'content']),
            this.sizeNumberField('font.size'),
            this.fontWeightField('font.weight', ['main', 'content']),
            this.fontTransformField('font.transform'),
            this.fontColorComboField('font.color', ['main', 'content', 'header']),

            this.comboField('icon.display', {
                [this.translateValue('HIDDEN')]: 'none',
                [this.translateValue('VISIBLE')]: 'inline-flex',
            }),
            this.fontColorComboField('icon.color', ['tab', 'main', 'content'], { ...this.preset('icon-color', 'main'), [this.translateValue('INHERIT')]: 'inherit' }),

            this.backgroundColorField('background.color', ['content', 'header']),
            this.borderColorField('border.color', ['tab', 'header', 'main', 'content']),

            
            this.fontColorComboField('active.font.color', ['main', 'content', 'header'], this.preset('active-font-color', 'main')),
            this.fontWeightField('active.font.weight', ['tab', 'main', 'content']),
            this.backgroundColorField('active.background.color', ['tab', 'content'], this.preset('active-background-color', 'main')),
            this.fontColorComboField('hover.font.color', ['main', 'content', 'header'], this.preset('hover-font-color', 'main')),
            this.backgroundColorField('hover.background.color', ['tab', 'content'], this.preset('hover-background-color', 'main')),

            this.comboField('active.indicator.style', {
                [this.translateValue('NONE')]: 'none',
                [this.translateValue('BOTTOM')]: 'bottom',
            }),
            this.backgroundColorField('active.indicator.color', ['tab', 'header'], {}, [0.1, 0.3, 0.5]),

        ];
    }

}
